import { config } from '../config';

const errorMessage = '[apiProducts] error to method';

export const apiProducts = {
  fetchAllProducts: async (axiosPrivate, { type = '' } = {}) => {
    try {
      const filter = new URLSearchParams({ type }).toString();
      const response = await axiosPrivate.get(`${config.API.PRODUCTS.ALL}?${filter}`);
      return response.data;
    } catch (error) {
      console.error(errorMessage + 'fetchAllProducts', error);
      throw error;
    }
  },
};
